export default function() {
    const menu = document.querySelector('.mobile-menu');

    if (!menu) return;

    const panels = Array.from(menu.querySelectorAll('.mobile-menu__panel'));
    const toggles = Array.from(menu.querySelectorAll('.mobile-menu__toggle'));
    const backButtons = Array.from(menu.querySelectorAll('.mobile-menu__back'));

    let activePanel = menu.querySelector('.mobile-menu__panel.is-center') || panels[0];
    let isAnimating = false;

    /**
     * Set a deterministic visual state for a panel.
     *
     * @param {HTMLElement} panel
     * @param {'left'|'center'|'right'} state
     */
    function setPanelState(panel, state) {
        panel.classList.remove('is-left', 'is-center', 'is-right');
        panel.classList.add(`is-${state}`);
    }

    /**
     * Sync aria-expanded for submenu toggles.
     *
     * Only the toggle that points to the active submenu gets aria-expanded="true".
     * Main panel active => everything false.
     */
    function syncExpandedState() {
        const activeName = activePanel?.dataset.panel || '';

        toggles.forEach((toggle) => {
            const expanded = toggle.dataset.target === activeName;
            toggle.setAttribute('aria-expanded', String(expanded));
        });
    }

    /**
     * Navigate to another panel.
     *
     * @param {string} targetName
     * @param {'forward'|'back'} direction
     */
    function goToPanel(targetName, direction = 'forward') {
        if (isAnimating) return;

        const targetPanel = menu.querySelector(`.mobile-menu__panel[data-panel="${targetName}"]`);
        if (!targetPanel || targetPanel === activePanel) return;

        isAnimating = true;

        if (direction === 'forward') {
            // Prepare target to enter from the right
            setPanelState(targetPanel, 'right');

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setPanelState(activePanel, 'left');
                    setPanelState(targetPanel, 'center');
                    activePanel = targetPanel;
                    syncExpandedState();
                });
            });
        } else {
            // Prepare target to enter from the left
            setPanelState(targetPanel, 'left');

            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setPanelState(activePanel, 'right');
                    setPanelState(targetPanel, 'center');
                    activePanel = targetPanel;
                    syncExpandedState();
                });
            });
        }
    }

    /**
     * Release animation lock after transform transition ends.
     */
    function handleTransitionEnd(event) {
        if (!event.target.classList.contains('mobile-menu__panel')) return;
        if (event.propertyName !== 'transform') return;

        isAnimating = false;
    }

    panels.forEach((panel) => {
        panel.addEventListener('transitionend', handleTransitionEnd);
    });

    toggles.forEach((toggle) => {
        toggle.addEventListener('click', function () {
            goToPanel(this.dataset.target, 'forward');
        });
    });

    backButtons.forEach((button) => {
        button.addEventListener('click', function () {
            goToPanel(this.dataset.back || 'main', 'back');
        });
    });

    syncExpandedState();
}

